import { render, staticRenderFns } from "./ShippingOrderInfo.vue?vue&type=template&id=1d3d7fba&scoped=true"
import script from "./ShippingOrderInfo.vue?vue&type=script&lang=ts"
export * from "./ShippingOrderInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3d7fba",
  null
  
)

export default component.exports